import { Container, Typography } from "@mui/material";
import React from "react";
import { useRouteError } from "react-router-dom";

const Error = () => {
  const error = useRouteError();
  const { status, statusText } = error;
  console.error(error);
  return (
    <div>
      <Container
        sx={{
          py: 6,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: 48,
              md: 72,
            },
            letterSpacing: {
              xs: 0,
              md: 8,
            },
          }}
          color="secondary"
          variant="h1"
          align="center"
          gutterBottom
        >
          {status}
        </Typography>
        <Typography color="info.main" variant="h3" align="center" gutterBottom>
          {statusText}
        </Typography>
      </Container>
    </div>
  );
};

export default Error;
